import { IRegionShort } from 'api/region/types';
import { Routes } from 'routes';

import { OuterPlanYourTripPropsType } from './types';
import { PlanYourTrip } from './Component';

interface IRegionPlanYourTripProps extends OuterPlanYourTripPropsType {
  region: IRegionShort,
}

const PlanYourTripRegionWrapper = ({
  region,
  ...props
}: IRegionPlanYourTripProps) => {
  const redirectLodgingPath = Routes.regionLodging(region);
  const redirectSkiRentalPath = '';
  const redirectBookFlightsPath = '';
  const redirectCarRentalPath = '';
  const { title } = region;

  return (
    <PlanYourTrip
      {...props}
      contextKey="region"
      title={title}
      redirectLodgingPath={redirectLodgingPath}
      redirectSkiRentalPath={redirectSkiRentalPath}
      redirectBookFlightsPath={redirectBookFlightsPath}
      redirectCarRentalPath={redirectCarRentalPath}
    />
  );
};

export default PlanYourTripRegionWrapper;
